import { ThunkResult } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { State } from "../model/State";
import { rebuildVariableScopesAndTriggerValidationAction } from "./ValidateProcess";

export const UPDATE_BPMN = "UPDATE_BPMN";
export function updateBpmn(updatedBpmn: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch({ type: UPDATE_BPMN, updatedBpmn: updatedBpmn });
        dispatch(rebuildVariableScopesAndTriggerValidationAction());
    };
}
export interface UpdateBpmnAction extends IAction {
    updatedBpmn: string;
}
